(() => {
  const DESKTOP = '(min-width: 750px)';
  const touched = new Map();

  const remember = (el, prop) => {
    if (!el) return;
    if (!touched.has(el)) touched.set(el, new Set());
    touched.get(el).add(prop);
  };

  const set = (el, prop, value) => {
    if (!el) return;
    remember(el, prop);
    el.style.setProperty(prop, value, 'important');
  };

  const clearDesktopStyles = () => {
    touched.forEach((props, el) => {
      if (!(el instanceof HTMLElement) || !el.isConnected) return;
      props.forEach((prop) => el.style.removeProperty(prop));
    });
    touched.clear();
  };

  const text = (el) => (el?.textContent || '').replace(/\s+/g, ' ').trim();

  const centerGuide = () => {
    const guideTitle = [...document.querySelectorAll('h1,h2,h3')]
      .find((el) => /^Encontrá tu talle ideal$/i.test(text(el)));
    if (!guideTitle) return;

    const section = guideTitle.closest('.shopify-section');
    if (!section) return;

    section.querySelectorAll('.group-block-content').forEach((content) => {
      set(content, 'align-items', 'center');
      set(content, 'justify-content', 'center');
      set(content, 'text-align', 'center');
      set(content, 'transform', 'none');
    });

    const paragraphs = [...section.querySelectorAll('p')]
      .filter((el) => /tabla para comparar los talles|Los talles pueden variar/i.test(text(el)));
    const guideButton = [...section.querySelectorAll('a,button,[role="button"]')]
      .find((el) => /Consultanos tus dudas/i.test(text(el)));

    const blocks = [
      guideTitle.closest('[id*="__text_"]') || guideTitle.parentElement,
      ...paragraphs.map((el) => el.closest('[id*="__text_"]') || el.parentElement),
      guideButton?.closest('[id*="__button_"]') || guideButton?.parentElement
    ].filter(Boolean);

    blocks.forEach((block) => {
      set(block, 'align-self', 'center');
      set(block, 'margin-left', 'auto');
      set(block, 'margin-right', 'auto');
      set(block, 'text-align', 'center');
      set(block, 'transform', 'none');
    });

    set(guideTitle, 'margin-left', 'auto');
    set(guideTitle, 'margin-right', 'auto');
    set(guideTitle, 'text-align', 'center');

    paragraphs.forEach((paragraph) => {
      set(paragraph, 'margin-left', 'auto');
      set(paragraph, 'margin-right', 'auto');
      set(paragraph, 'text-align', 'center');
    });

    if (guideButton) {
      set(guideButton, 'margin-left', 'auto');
      set(guideButton, 'margin-right', 'auto');
    }
  };

  const alignFooter = () => {
    const footer = document.querySelector('footer');
    if (!footer) return;

    const collabHeading = [...footer.querySelectorAll('h1,h2,h3,h4,h5,h6,p')]
      .find((el) => /^Colaboraciones\s*&\s*Canjes$/i.test(text(el)));
    const paragraph = [...footer.querySelectorAll('p')]
      .find((el) => /influencer|creador\/a de contenido|campañas o canjes/i.test(text(el)));
    const regret = [...footer.querySelectorAll('a,button,[role="button"]')]
      .find((el) => /BOT[ÓO]N DE ARREPENTIMIENTO/i.test(text(el)));

    if (collabHeading) {
      const collabPanel = collabHeading.closest('.group-block') || collabHeading.parentElement;
      const collabContent = collabPanel?.querySelector('.group-block-content') || collabPanel;
      const outerContent = collabPanel?.parentElement;
      const outerGroup = outerContent?.closest('.group-block');
      const headingBlock = collabHeading.closest('[id*="__text_"]') || collabHeading.parentElement;
      const paragraphBlock = paragraph?.closest('[id*="__text_"]') || paragraph?.parentElement;

      if (outerGroup && outerGroup !== collabPanel) {
        set(outerGroup, 'width', '100%');
        set(outerGroup, 'max-width', '100%');
        set(outerGroup, 'margin-left', '0');
        set(outerGroup, 'margin-right', '0');
        set(outerGroup, 'transform', 'none');
      }

      if (outerContent) {
        set(outerContent, 'display', 'flex');
        set(outerContent, 'flex-direction', 'row');
        set(outerContent, 'align-items', 'center');
        set(outerContent, 'justify-content', 'flex-start');
        set(outerContent, 'width', '100%');
        set(outerContent, 'max-width', '100%');
        set(outerContent, 'margin', '0');
        set(outerContent, 'padding', '0');
        set(outerContent, 'transform', 'none');
      }

      if (collabPanel) {
        set(collabPanel, 'position', 'relative');
        set(collabPanel, 'left', 'auto');
        set(collabPanel, 'right', 'auto');
        set(collabPanel, 'width', '50%');
        set(collabPanel, 'max-width', '50%');
        set(collabPanel, 'margin-left', '0');
        set(collabPanel, 'margin-right', 'auto');
        set(collabPanel, 'padding', '0 0 24px');
        set(collabPanel, 'transform', 'none');
        set(collabPanel, 'box-sizing', 'border-box');
        set(collabPanel, 'text-align', 'center');
      }

      if (collabContent) {
        set(collabContent, 'display', 'flex');
        set(collabContent, 'flex-direction', 'column');
        set(collabContent, 'align-items', 'center');
        set(collabContent, 'justify-content', 'center');
        set(collabContent, 'gap', '8px');
        set(collabContent, 'width', '100%');
        set(collabContent, 'text-align', 'center');
        set(collabContent, 'transform', 'none');
      }

      [headingBlock, paragraphBlock].forEach((block) => {
        if (!block) return;
        set(block, 'position', 'relative');
        set(block, 'left', 'auto');
        set(block, 'right', 'auto');
        set(block, 'display', 'flex');
        set(block, 'align-items', 'center');
        set(block, 'justify-content', 'center');
        set(block, 'align-self', 'center');
        set(block, 'width', '100%');
        set(block, 'max-width', '520px');
        set(block, 'margin-left', 'auto');
        set(block, 'margin-right', 'auto');
        set(block, 'padding', '0');
        set(block, 'transform', 'none');
        set(block, 'text-align', 'center');
      });

      set(collabHeading, 'margin-left', 'auto');
      set(collabHeading, 'margin-right', 'auto');
      set(collabHeading, 'max-width', '520px');
      set(collabHeading, 'text-align', 'center');

      if (paragraph) {
        set(paragraph, 'margin-left', 'auto');
        set(paragraph, 'margin-right', 'auto');
        set(paragraph, 'max-width', '520px');
        set(paragraph, 'text-align', 'center');
      }
    }

    if (regret) {
      const slot = regret.closest('.gd-regret-footer-slot') || regret.parentElement;
      if (slot) {
        set(slot, 'position', 'absolute');
        set(slot, 'left', '75%');
        set(slot, 'right', 'auto');
        set(slot, 'top', 'auto');
        set(slot, 'bottom', '-84px');
        set(slot, 'transform', 'translateX(-50%)');
        set(slot, 'z-index', '2');
        set(slot, 'padding', '0');
      }

      set(regret, 'position', 'static');
      set(regret, 'left', 'auto');
      set(regret, 'right', 'auto');
      set(regret, 'top', 'auto');
      set(regret, 'bottom', 'auto');
      set(regret, 'display', 'inline-flex');
      set(regret, 'align-items', 'center');
      set(regret, 'justify-content', 'center');
      set(regret, 'width', 'auto');
      set(regret, 'max-width', 'none');
      set(regret, 'min-width', 'auto');
      set(regret, 'min-height', 'auto');
      set(regret, 'margin', '0');
      set(regret, 'padding', '12px 18px');
      set(regret, 'transform', 'none');
      set(regret, 'font-size', '12px');
      set(regret, 'line-height', '1.2');
      set(regret, 'white-space', 'nowrap');
      set(regret, 'text-align', 'center');
    }
  };

  const apply = () => {
    if (!window.matchMedia(DESKTOP).matches) {
      clearDesktopStyles();
      return;
    }
    centerGuide();
    alignFooter();
  };

  const start = () => {
    apply();
    [80, 250, 600, 1200, 2000].forEach((ms) => setTimeout(apply, ms));
    new MutationObserver(() => requestAnimationFrame(apply))
      .observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:section:select', apply);
    window.addEventListener('resize', apply, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
